// extracted by mini-css-extract-plugin
export default {"img_header":"Navbar_img_header__02jXW"};